// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".last-scan-item[data-v-c95d8894]{transition:.2s;max-width:100%}.last-scan-item-wrap[data-v-c95d8894]{max-width:100%;width:-moz-fit-content;width:fit-content;height:21px}.last-scan-item[data-v-c95d8894]:hover{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
